import React from 'react';
import Img from 'gatsby-image';
import styled from '@emotion/styled';
import {
  rgba, timingFunctions, adjustHue, mix
} from 'polished';

import { isEmpty } from '../../utils';
import { infoOverlay, SocLink, HiddenText } from '../elements';

export default class Album extends React.Component {
  render() {
    const { album, gap } = this.props;

    return (
      <CellWrapper gap={gap}>
        <CellInner id={album.id}>
          <Img
            fluid={album.featured_media.localFile.childImageSharp.fluid}
            css={{
              height: 0,
              position: 'relative',
              paddingBottom: '100%',
            }}
          />
          <Info>
            <Social>
              {!isEmpty(album.acf.itunes) && (
                <SocLink href={album.acf.itunes} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-apple" />
                  <HiddenText>Apple Music</HiddenText>
                </SocLink>
              )}
              {!isEmpty(album.acf.spotify) && (
                <SocLink href={album.acf.spotify} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-spotify" />
                  <HiddenText>Spotify</HiddenText>
                </SocLink>
              )}
              {!isEmpty(album.acf.youtube) && (
                <SocLink href={album.acf.youtube} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube" />
                  <HiddenText>YouTube</HiddenText>
                </SocLink>
              )}
            </Social>
            <h2
              css={{
                fontSize: '2rem',
                lineHeight: 0.8,
                letterSpacing: -1,
                marginBottom: 16,
              }}
            >
              {album.title}
              <br />
              <span
                css={{
                  opacity: 0.6,
                  fontSize: '0.7em',
                }}
              >
                {album.acf.year}
              </span>
            </h2>
            <p
              css={{
                fontSize: '0.9rem',
                margin: 0,
                paddingTop: 7,
                fontWeight: 600,
                textTransform: 'uppercase',
                lineHeight: 1,
                letterSpacing: 1,
              }}
            >
              {album.acf.artist}
            </p>

            {!isEmpty(album.acf.description) && (
              <p
                css={{
                  fontSize: '0.7rem',
                  margin: 0,
                  paddingTop: 8,
                  fontWeight: 400,
                  lineHeight: 1.2,
                }}
              >
                {album.acf.description}
              </p>
            )}
          </Info>
        </CellInner>
      </CellWrapper>
    );
  }
}

const Info = styled.div`
  ${infoOverlay}
  ${'' /* text-align: right; */}
  color: #fff !important;
`;

const CellWrapper = styled.div`
  padding: 0 ${p => p.gap}px;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  width: 100%;
`;

const CellInner = styled.div`
  position: relative;
  overflow: hidden;

  &:hover {
    ${Info} {
      opacity: 1;
      transform: scale(1);
      transition: all 0.5s ${timingFunctions('linearSpring')};
    }
  }
`;

const Social = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  ${'' /* margin-right: -0.5rem; */}
`;
